export {default} from './admin.vue'